import { render, staticRenderFns } from "./Ods.vue?vue&type=template&id=43213aa8&scoped=true"
import script from "./Ods.vue?vue&type=script&lang=js"
export * from "./Ods.vue?vue&type=script&lang=js"
import style0 from "./Ods.vue?vue&type=style&index=0&id=43213aa8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43213aa8",
  null
  
)

export default component.exports